import * as axiosService from "../axiosService";

export const getFleetSupplierList = (payload) => {
    const queryParams = [];

    if (payload.search) {
        queryParams.push(`searchText=${payload.search}`);
    }
    if (payload.pageNumber) {
        queryParams.push(`pageNumber=${payload.pageNumber}`);
    }
    if (payload.pageSize) {
        queryParams.push(`pageSize=${payload.pageSize}`);
    }
    if (payload.sortBy) {
        queryParams.push(`sortBy=${payload.sortBy}`);
    }
    if (payload.sortOrder) {
        queryParams.push(`sortOrder=${payload.sortOrder}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }
    if (payload.status) {
        queryParams.push(`status=${payload.status}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/GetFleetSupplierList${queryString}`)
};

export const OnboardingNewSupplier = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/SaveUserInfo`,payload);
};

export const addSupplierKyc = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/SaveUserKycInfo`,payload);
};
export const addSupplierInFleet = (supplierId) => {
    let payload={
        externalSupplierId:supplierId
         }
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/FleetManagement/AddSupplierInFleet`,payload);
};

export const CheckSupplierExistanceByInternalSourcer = (countryCode,mobile) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/CheckSupplierExistanceByInternalSourcer?countryCode=${countryCode}&mobileNo=${mobile}`);
};

export const getSupplierKycInfo = (supplierId) => {
    const queryParams = [];
    if (supplierId) {
        queryParams.push(`userId=${supplierId}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/GetKYCDetailsForUserProfile${queryString}`);
};
export const getAccountDetails = (supplierId) => {
//    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/GetBasicInfo?supplierId=${userId}`);
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/GetBasicInfo?userId=${supplierId}`);

};


export const AddSupplierInFleet = (externalSupplierId) => {
    //    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Supplier/GetBasicInfo?supplierId=${userId}`);
       return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/AddSupplierInFleet`,externalSupplierId);
    
    };

    export const RemoveSupplierFromFleet = (payload) => {
        return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/RemoveSupplierFromFleet`, payload);
    };